import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeKnowledgeOverviewResponseDataSchema,
  DataResponse,
  GetBackofficeKnowledgeMetricsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeKnowledgeMetricsSchema>
type Response = DataResponse<z.infer<typeof BackofficeKnowledgeOverviewResponseDataSchema>>

export const getBackofficeKnowledgeOverviewQuery = ({ query }: { query: Query }) => {
  return queryOptions({
    placeholderData: () => undefined,
    queryKey: ["backofficeKnowledgeOverview", query],
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>("/backoffice/knowledge/overview", {
        params: query,
        signal,
      })
      return data.data
    },
  })
}
